import React, { useCallback } from 'react'
import { Button, Modal, Toast } from '@ow/comps'
import { updateXlsxTbData } from '@vt/apis/lib-ex/v2/givrali'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { pick, isArray, find } from 'lodash-es'

const AreaImporter = function ({ children }) {
  const { appId } = useAppEx()
  const { tbId, fetchTbData, layouts } = useTbViewStore((state) =>
    pick(state, ['tbId', 'fetchTbData', 'layouts'])
  )

  const { elements } = pick(layouts.layouts.navMenu, ['elements'])

  const changeFile = async (file) => {
    let slugs = ['checkDate', 'code', 'organization']
    if (elements && elements[0]) {
      const { rightElements } = elements[0]
      if (rightElements && isArray(rightElements)) {
        const obj = find(rightElements, ['actionType', 'areaImporter'])
        if (obj.slugs) {
          console.log('sssss', obj.slugs)
          slugs = obj.slugs
        }
      }
    }
    const { files } = file.target
    const formData = new FormData()
    // 通过append() 方法向对象中添加files键值对
    formData.append('file', files[0])
    Toast.warning({
      title: '正在导入, 请稍候',
      description: '',
    })
    await updateXlsxTbData(appId, tbId, formData, slugs)

    Toast.success({
      title: '导入成功',
      description: '',
    })
    fetchTbData()
  }

  const FooterComp = useCallback(
    ({ close }) => (
      <div>
        <Button
          type="primary"
          className="mr-2 relative rounded-md cursor-pointer flex items-center justify-center bg-primary"
        >
          <input
            className="w-full h-full absolute opacity-0"
            type="file"
            accept=".xlsx, .xls"
            name="file"
            onChange={(file) => {
              changeFile(file)
              close()
            }}
          />
          覆盖上传
        </Button>
      </div>
    ),
    []
  )

  return (
    <Modal
      nested
      size="lg"
      showCloseButton
      trigger={children}
      footer={FooterComp}
    >
      <div
        className="w-full flex flex-col items-center"
        style={{ fontSize: '0.8125rem' }}
      >
        <div className="w-full text-white-400 mt-4 flex justify-between items-center">
          <div>按照要求上传需要覆盖的点位数据表</div>
        </div>
      </div>
    </Modal>
  )
}

export default AreaImporter
